import React from 'react';
import { translate } from 'admin-on-rest';

const BRAND_BLUE = '#284263';
const BRAND_ORANGE = '#fd9512';

const styles = {
    strip:        { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 },
    tile:         { background: '#fff', borderRadius: 10, padding: '14px 18px', boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)', borderTop: '3px solid #e5e7eb', position: 'relative', overflow: 'hidden' },
    tileToday:    { borderTopColor: BRAND_BLUE },
    tileMonth:    { borderTopColor: BRAND_ORANGE },
    tagToday:     { display: 'inline-block', fontSize: 9, fontWeight: 700, letterSpacing: 0.7, color: BRAND_BLUE, background: '#eef2ff', padding: '2px 8px', borderRadius: 999, textTransform: 'uppercase' },
    tagMonth:     { display: 'inline-block', fontSize: 9, fontWeight: 700, letterSpacing: 0.7, color: '#92400e', background: '#fef3c7', padding: '2px 8px', borderRadius: 999, textTransform: 'uppercase' },
    label:        { fontSize: 11, color: '#6b7280', letterSpacing: 0.3, fontWeight: 600, textTransform: 'uppercase', marginTop: 8 },
    value:        { fontSize: 24, fontWeight: 700, color: '#111827', lineHeight: 1.1, fontVariantNumeric: 'tabular-nums', marginTop: 2 },
    breakdown:    { fontSize: 11, color: '#9ca3af', marginTop: 6, fontVariantNumeric: 'tabular-nums', display: 'flex', gap: 12 },
    breakItem:    { display: 'flex', alignItems: 'center', gap: 4 },
    dot:          { width: 6, height: 6, borderRadius: '50%', display: 'inline-block' },
    skeleton:     { padding: 20, color: '#9ca3af', textAlign: 'center', fontSize: 13, background: '#fff', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' },
};

const fmt = (n) => (n != null ? Number(n).toLocaleString('nl-NL') : '—');
const fmtEur = (n) => (n != null ? `€ ${Number(n).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '—');

const Tile = ({ tag, tagStyle, label, value, breakdown, accent }) => (
    <div style={{ ...styles.tile, ...(accent === 'month' ? styles.tileMonth : styles.tileToday) }}>
        <span style={tagStyle}>{tag}</span>
        <div style={styles.label}>{label}</div>
        <div style={styles.value}>{value}</div>
        {breakdown}
    </div>
);

export default translate(({ reports }) => {
    if (typeof reports === 'undefined') {
        return <div style={styles.skeleton}>Statistieken laden...</div>;
    }

    const breakdownToday = (
        <div style={styles.breakdown}>
            <span style={styles.breakItem}><span style={{ ...styles.dot, background: BRAND_BLUE }} />Cloudhints {fmtEur(reports.today_cost_ch)}</span>
            <span style={styles.breakItem}><span style={{ ...styles.dot, background: '#9ca3af' }} />Daisycon {fmtEur(reports.today_cost_dc)}</span>
        </div>
    );
    const breakdownMonth = (
        <div style={styles.breakdown}>
            <span style={styles.breakItem}><span style={{ ...styles.dot, background: BRAND_ORANGE }} />Cloudhints {fmtEur(reports.month_cost_ch)}</span>
            <span style={styles.breakItem}><span style={{ ...styles.dot, background: '#9ca3af' }} />Daisycon {fmtEur(reports.month_cost_dc)}</span>
        </div>
    );

    return (
        <div style={styles.strip}>
            <Tile tag="Vandaag" tagStyle={styles.tagToday} label="Kliks" value={fmt(reports.today_clicks)} accent="today" />
            <Tile tag="Vandaag" tagStyle={styles.tagToday} label="Omzet" value={fmtEur(reports.today_cost)} breakdown={breakdownToday} accent="today" />
            <Tile tag="Deze maand" tagStyle={styles.tagMonth} label="Kliks" value={fmt(reports.month_clicks)} accent="month" />
            <Tile tag="Deze maand" tagStyle={styles.tagMonth} label="Omzet" value={fmtEur(reports.month_cost)} breakdown={breakdownMonth} accent="month" />
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/dashboard/AggregatesReport.js